import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import en from "./locales/en";
import pt from "./locales/pt";

// Para debug no console (remover em produção)
const isDebug = false;

// Limpar qualquer preferência de idioma salva
try {
  localStorage.removeItem('i18nextLng');
} catch (e) {
  console.log('Não foi possível acessar localStorage');
}

i18n
  // Detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    debug: isDebug,
    resources: {
      en: {
        translation: en
      },
      pt: {
        translation: pt
      },
    },
    fallbackLng: "en",      // Fallback para inglês se o idioma não for suportado
    supportedLngs: ["en", "pt"],  // Idiomas suportados (note a ordem mudada)
    load: 'languageOnly', // Carregar apenas o idioma principal (en em vez de en-US)
    interpolation: {
      escapeValue: false,  // Not needed for React
    },
    detection: {
      order: ['navigator', 'querystring', 'htmlTag'],  // Ordem de detecção de idioma
      lookupQuerystring: 'lng',  // ?lng=en na URL também funcionará
      caches: [],  // Desabilitar cache para forçar a detecção sempre
    }
  });

// Debug de idioma detectado
if (isDebug) {
  console.log('Detected language:', i18n.language);
  console.log('Browser language:', navigator.language);
}

export default i18n;
